/**
 * ProposalDetailContainer
 * --
 */
import React from 'react';
import ProposalDetailPresenter from './ProposalDetailPresenter';

const ProposalDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProposalDetailPresenter />
    </>
  );
};

export default ProposalDetailContainer;
